import React, { createContext, useContext } from 'react'
import { GraphQLClient } from 'graphql-request'
import { graphqlClient } from './graphql-client'

interface GraphQLContextType {
  client: GraphQLClient
}

const GraphQLContext = createContext<GraphQLContextType | undefined>(undefined)

export const useGraphQLClient = () => {
  const context = useContext(GraphQLContext)
  if (!context) {
    throw new Error('useGraphQLClient must be used within a GraphQLProvider')
  }
  return context.client
}

interface GraphQLProviderProps {
  children: React.ReactNode
}

export const GraphQLProvider: React.FC<GraphQLProviderProps> = ({
  children,
}) => {
  return (
    <GraphQLContext.Provider value={{ client: graphqlClient }}>
      {children}
    </GraphQLContext.Provider>
  )
}
